import { FC, useEffect } from 'react';
import { headerStore } from '@modules/header/adapter/outbound/stores/header.store';
import { menuStore } from '@modules/header/adapter/outbound/stores/menu.store';
import useLockedBody from '@shared/utils/hooks/useLockedBody.utils';
import CategoryMenuMobileLogic from '../category/CategoryMenuMobile.logic';
import PromotionMenuMobileLogic from '../promotion/PromotionMenuMobile.logic';
import MainMenuMobile from './MainMenuMobile';
const MainMenuMobileLogic: FC = () => {
  const [_locked, setLocked] = useLockedBody(false, 'root');
  const {
    isMenuMobileOpen,
    setIsMenuMobileOpen
  } = headerStore(state => state);
  const {
    fetchCategoryMenu,
    mainMenuMobile
  } = menuStore(state => state);
  useEffect(() => {
    setLocked(isMenuMobileOpen);
    if (isMenuMobileOpen) fetchCategoryMenu();
  }, [isMenuMobileOpen]);
  return <>
            <MainMenuMobile isMenuOpen={isMenuMobileOpen} setIsOpen={setIsMenuMobileOpen} bottomMenuList={mainMenuMobile.bottomMenu} optionMenuList={mainMenuMobile.optionMenu} />
            <CategoryMenuMobileLogic />
            <PromotionMenuMobileLogic />
        </>;
};
export default MainMenuMobileLogic;